/**
 * Best-effort subscribed plan for the browser (localStorage).
 * Set when returning from Stripe with ?checkout=success&plan=weekly|monthly|annual on the landing URL.
 * Configure each Payment Link success URL in Stripe to include &plan=... matching that product.
 */

const STORAGE_KEY = "rareroles_subscribed_plan";
const PLANS = new Set(["weekly", "monthly", "annual"]);

/** sessionStorage mirror for /auth/me entitlement; keep key in sync with EntitlementContext usage. */
export const ENTITLEMENT_SESSION_CACHE_KEY = "rareroles_entitlement_v1";

export function getStoredSubscribedPlan() {
  if (typeof window === "undefined") return null;
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v && PLANS.has(v)) return v;
  } catch {
    /* ignore */
  }
  return null;
}

export function setStoredSubscribedPlan(plan) {
  if (!plan || !PLANS.has(plan)) return;
  try {
    localStorage.setItem(STORAGE_KEY, plan);
    if (typeof window !== "undefined") {
      window.dispatchEvent(new CustomEvent("rareroles:subscription-changed"));
    }
  } catch {
    /* ignore */
  }
}

/** Removes checkout success hint; paywall should not show "Your Plan" when signed out. */
export function clearStoredSubscribedPlan() {
  if (typeof window === "undefined") return;
  try {
    localStorage.removeItem(STORAGE_KEY);
    window.dispatchEvent(new CustomEvent("rareroles:subscription-changed"));
  } catch {
    /* ignore */
  }
}

export function clearSessionEntitlementCache() {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.removeItem(ENTITLEMENT_SESSION_CACHE_KEY);
  } catch {
    /* ignore */
  }
}

/** Run when clearing auth so anonymous users never see subscription UI tied to a prior session. */
export function clearSubscriptionClientHints() {
  clearStoredSubscribedPlan();
  clearSessionEntitlementCache();
}
